import React from 'react'
import { HiOutlineMenu } from 'react-icons/hi'
import { Link } from 'react-router-dom'
import { usePortfolioStore } from '../../store'
import { Heading, Icon, Text } from '../ui'

const Header: React.FC = () => {
  const toggleSidePanel = usePortfolioStore(state => state.toggleSidePanel)

  return (
    <header className="site-header">
      <div className="header-container">
        <div className="header-brand">
          <Link to="/" className="brand-link">
            <div className="brand-content">
              <img
                src="/logo.png"
                alt="Lucas Stufflebeam Logo"
                className="brand-logo"
              />
              <div className="brand-text">
                <Heading
                  as="h1"
                  size="lg"
                  variant="gradient"
                  className="brand-title"
                >
                  Lucas Stufflebeam
                </Heading>
                <Text
                  as="span"
                  size="xs"
                  variant="tertiary"
                  className="brand-subtitle"
                >
                  Principal Software Architect
                </Text>
              </div>
            </div>
          </Link>
        </div>

        {/* Header Actions */}
        <div className="header-actions">
          <button
            className="side-panel-toggle"
            onClick={toggleSidePanel}
            aria-label="Open navigation and portfolio panel"
            title="Navigation & Contact Info"
          >
            <Icon icon={HiOutlineMenu} size="lg" color="primary" />
            <span className="sr-only">Navigation Panel</span>
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header
